module.exports = __webpack_public_path__ + "static/media/logo.fc55a3a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 88
// module chunks = 0